export { default } from './Subtitle';
